import { css as _css } from "@emotion/core";
import React from 'react';
import * as styles from './menu-separator.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MenuSeparator = _ref => {
  var _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'column' : _ref$orientation;
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([orientation === 'row' && styles.row, orientation === 'column' && styles.column])
  });
};
export default MenuSeparator;